












import Vue from 'vue';

export default Vue.extend({
  name: 'HubCheckbox' as string,

  inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selected: this.value,
    };
  },

  watch: {
    selected(): void {
      this.$emit('input', this.selected);
    },
    value(): void {
      this.selected = this.value;
    },
  },
});
